export const defaultSorted = [{ dataField: "id", order: "asc" }];

export const initialFilter = {
  searchKey: "",
  pageNumber: 1,
  pageSize: 20,
  sortBy: "created_at",
  sortOrder: "descend",
};
